import React from 'react'
import "./styles/selectboard.css"

function AddedBoard() {
  return (
    <div className='ss'>
        <div className='addedtask-container'>
            <p>Board updated successfully</p>
        </div>
    </div>
  )
}

export default AddedBoard